export default __webpack_public_path__ + "static/media/menu-transaksi.d051562b.svg";